module.exports = __webpack_public_path__ + "img/logo.7ae33d1b.png";